const Main = () => import('@pages/Main')
const Home = () => import('@pages/Main/Home')
const Service = () => import('@pages/Main/Service')
const User = () => import('@pages/Main/User')
const ConsultShow = () => import('@pages/Consult/Show')

export const main = [
  {
    path: '/',
    component: Main,
    meta: {auth: true}, // 是否需要认证
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        meta: {auth: true /* 是否需要认证 */, title: '首页', hideBack: true}
      },
      {
        path: 'service',
        name: 'Service',
        component: Service,
        meta: {auth: true, title: '课程表', hideBack: true}
      },
      {
        path: 'user',
        name: 'User',
        component: User,
        meta: {auth: true, title: '个人', hideBack: true}
      },
      {
        path: 'consults/:consultId',
        name: 'ConsultShow',
        component: ConsultShow,
        meta: {auth: true, title: '新闻详情'}
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/main.route.js